<template>
  <section class="createAccount-area inner-page pb-5">
    <!-- <ConfirmDialog appendTo="#app" :draggable="false" /> -->
    <div class="container">
      <div class="createAccountform dir-rtl">
        <div class="form-cont">
          <div v-if="active_step <= 6">
            <Steps :model="items" />
          </div>
          <div
            class="form-container"
            :style="active_step <= 6 ? 'border-top: 1px solid #dadada' : ''"
          >
            <Step1
              :payload="payload"
              :verified_info="verified_info"
              @close="close"
              @next="next"
              @existingRequest="onExistingRequest"
              @emailLookup="onEmailLookup"
              :email_lookup="email_lookup"
              v-if="active_step == 1"
            />
            <Step2
              :payload="payload"
              :verified_info="verified_info"
              :apierrors="apierrors"
              @close="close"
              @next="next"
              @fileChange="fileChange"
              @removeFile="removeFile"
              v-else-if="active_step == 2"
            />
            <Step3 
              :payload="payload"
              :apierrors="apierrors"
              @close="close" 
              @next="next" 
              @fileChange="fileChange"
              @removeFile="removeFile"
              v-else-if="active_step == 3" 
            />
            <Step4
              :payload="payload"
              :apierrors="apierrors"
              @close="close"
              @next="next"
              @fileChange="fileChange"
              @removeFile="removeFile"
              @verifyIBAN="() => (payload.is_iban_verified = true)"
              v-else-if="active_step == 4"
            />
            <Step5
              :payload="payload"
              :apierrors="apierrors"
              :prefill_sp_dropped="prefill_sp_dropped"
              @close="close"
              @next="next"
              @addServiceProvider="addServiceProvider"
              @setPayload="setPayload"
              @removeServiceProvider="removeServiceProvider"
              @fileChangeInProvider="fileChangeInProvider"
              @removeFileFromProvider="removeFileFromProvider"
              v-else-if="active_step == 5"
            />
            <Step6
              :payload="payload"
              :verified_info="verified_info"
              :apierrors="apierrors"
              @openVerificationStep="openVerificationStep"
              @close="close"
              @next="next"
              v-else-if="active_step === 6 && !open_verification_step"
            />
            <Step6Verification
              :payload="payload"
              :submit_locked="submit_locked"
              @closeVerificationStep="closeVerificationStep"
              @createCharity="createCharity"
              @setPayload="setPayload"
              :verified_info="verified_info"
              ref="step6Verification"
              v-else-if="active_step == 6 && open_verification_step"
            />
            <AfterSubmitModal
              :display="open_modal"
              :is_success="is_success"
              :message="submit_error_message"
              @close="closeModal"
            />
            <ExistingRequestModal
              :display="show_existing_request_modal"
              :charityRequest="existing_request"
              @reuse="reuseExistingRequest"
              @decline="declineExistingRequest"
            />
            <AlertBox
              :showModal="registration_closed"
              :closable="false"
              title="طلبات تسجيل الجمعيات موقوفة هذه الفترة"
              actionLabel="العودة إلى الصفحة الرئيسية"
              @action="$router.push('/home')"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Steps from "primevue/steps";
import Step1 from "./step1.vue";
import Step2 from "./step2.vue";
import Step3 from "./step3.vue";
import Step4 from "./step4.vue";
import Step5 from "./step5.vue";
import Step6 from "./step6.vue";
import Step6Verification from "./step6_verification.vue";
import AfterSubmitModal from "./after-submit-modal";
import ExistingRequestModal from "./existing-request-modal.vue";
import AlertBox from "@/components/layout/AlertBox.vue";
import { getLocalValue, setLocalValue } from "@/hooks/useLocalStorage";
import CharityRegisterService from "@/services/charity-register.service";
import AuthService from "@/services/auth.service";

import moment from "moment";
import { toHijri } from "hijri-converter";
import { toBase64, prefilledFile } from "@/helpers/helpers";

// keys the applicant re-verifies from scratch: pre-fill never carries them over
const VERIFICATION_FLAGS = [
  "is_email_verified",
  "is_mobile_verified",
  "is_charity_email_verified",
  "is_iban_verified",
  "is_chairman_mobile_verified",
];
// stored as { url, name, size } by the steps, returned as a bare URL by the lookup
const FILE_FIELDS = [
  "charity_logo",
  "license_attachment",
  "bank_account_attachment",
];
// onboarding_requirement is nested in the payload, flat in the wizard
const ONBOARDING_REQUIREMENT_FIELDS = [
  "auth_letter",
  "basic_regulations",
  "governance_report",
  "financial_statement",
  "patient_waitlist",
];
const DATE_FIELDS = [
  "hijri_birthdate",
  "gregorian_birthdate",
  "license_expiry_hijri_date",
  "license_expiry_gregorian_date",
];
// wizard-only keys, never taken from the lookup payload
const NON_PREFILLABLE_FIELDS = [
  "id",
  "flag",
  "number_of_retry",
  "is_accepted_terms",
  "source_request_id",
  ...VERIFICATION_FLAGS,
];
const REREGISTER_STORAGE_KEY = "charity_reregister";
const EMAIL_LOOKUP_STORAGE_KEY = "charity_email_lookup";

const SUBMIT_ERROR_MESSAGES = {
  active_request_exists:
    "لديك طلب تسجيل قائم بهذا البريد الإلكتروني، يرجى متابعة طلبك الحالي",
  source_request_already_reused:
    "تم بالفعل إنشاء طلب جديد من هذا البريد الإلكتروني",
  source_request_not_reusable:
    "تعذر استخدام الطلب السابق، يرجى التحقق من البريد الإلكتروني مرة أخرى",
  source_request_not_found:
    "لم يتم العثور على الطلب السابق، يرجى التحقق من البريد الإلكتروني مرة أخرى",
  submission_failed: "تعذر إرسال الطلب، يرجى إعادة المحاولة",
};
// these never succeed on a retry — the submit button stays disabled
const TERMINAL_SUBMIT_ERRORS = [
  "active_request_exists",
  "source_request_already_reused",
];

export default {
  name: "SignIn",
  components: {
    Steps,
    Step1,
    Step2,
    Step3,
    Step4,
    Step5,
    Step6,
    Step6Verification,
    AfterSubmitModal,
    ExistingRequestModal,
    AlertBox,
  },
  data() {
    return {
      open_modal: false,
      registration_closed: false,
      is_success: null,
      submit_error_message: null,
      show_existing_request_modal: false,
      existing_request: null,
      pending_prefill: null,
      // set when a pre-filled request's service providers could not be trusted
      prefill_sp_dropped: false,
      // the email the pre-fill belongs to; editing away from it drops the reuse
      reregister_email: null,
      email_lookup: null,
      submit_locked: false,
      active_step: 1,
      items: [
        {
          label: "1",
          to: `/create-account/1`,
        },
        {
          label: "2",
          to: "/create-account/2",
        },
        {
          label: "3",
          to: "/create-account/3",
        },
        {
          label: "4",
          to: "/create-account/4",
        },
        {
          label: "5",
          to: "/create-account/5",
        },
        {
          label: "6",
          to: "/create-account/6",
        },
      ],
      loading: false,
      error: null,
      open_verification_step: false,
      payload: {
        id: 0,
        // id of the terminal request being re-registered from; omitted when absent
        source_request_id: null,
        national_id: null,
        hijri_birthdate: null,
        gregorian_birthdate: null,
        mobile_number: null,
        email: null,
        the_charity_manager_is_the_chairman: false,

        is_mobile_verified: false,
        is_email_verified: false,

        is_chairman_mobile_verified: false,
        is_charity_email_verified: false,

        iban: null,
        is_iban_verified: false,
        number_of_retry: 0,

        charity_license_number: null,
        license_expiry_hijri_date: null,
        license_expiry_gregorian_date: null,
        license_attachment: null,

        bank_name: null,
        account_holder_name: null,
        bank_account_attachment: null,

        region: null,
        city: null,
        charity_type: null,
        charity_logo: null,
        charity_name: null,
        charity_specialization: null,
        charity_phone: null,
        charity_email: null,
        charity_website: null,
        charity_twitter: null,
        longitude:46.664733 ,
        latitude:24.710988 ,
        chairman_name: null,
        chairman_mobile: null,

        number_of_service_provider_agreements: null,
        service_provider: null,

        association_director_name: null,
        is_accepted_terms: false,

        flag: null,

        auth_letter: null,
        basic_regulations: null,
        governance_report: null,
        financial_statement: null,
        patient_waitlist: null,
      },
      apierrors: {
        national_id: null,
        hijri_birthdate: null,
        gregorian_birthdate: null,
        mobile_number: null,
        email: null,
        the_charity_manager_is_the_chairman: null,

        is_mobile_verified: null,
        is_email_verified: null,

        is_chairman_mobile_verified: null,
        is_charity_email_verified: null,

        iban: null,
        is_iban_verified: null,
        number_of_retry: null,

        charity_license_number: null,
        license_expiry_hijri_date: null,
        license_expiry_gregorian_date: null,
        license_attachment: null,

        bank_name: null,
        account_holder_name: null,
        bank_account_attachment: null,

        region: null,
        city: null,
        charity_type: null,
        charity_logo: null,
        charity_name: null,
        charity_specialization: null,
        charity_phone: null,
        charity_email: null,
        charity_website: null,
        charity_twitter: null,
        chairman_name: null,
        chairman_mobile: null,

        number_of_service_provider_agreements: null,
        service_provider: null,

        association_director_name: null,
        is_accepted_terms: null,

        flag: null,

        auth_letter: null,
        basic_regulations: null,
        governance_report: null,
        financial_statement: null,
        patient_waitlist: null,
      },
      verified_info: {
        first_name: null,
        last_name: null,
        father_name: null,
        gender: null,
        identity_card_expiry: null,
      },
      gregorian_max_date: null,
      hijri_max_date: null,
      userFound: false,
      autoCloseTimeout: null,
    };
  },
  methods: {
    createAccount() {},
    onExistingRequest(result) {
      if (
        this.payload.source_request_id &&
        this.reregister_email === this.payload.email
      ) {
        return;
      }
      this.existing_request = result.charity_request;
      this.pending_prefill = result.prefill;
      this.show_existing_request_modal = true;
    },
    onEmailLookup(match_type) {
      this.email_lookup = { email: this.payload.email, match_type };
      setLocalValue(EMAIL_LOOKUP_STORAGE_KEY, this.email_lookup);
    },
    clearEmailLookup() {
      this.email_lookup = null;
      localStorage.removeItem(EMAIL_LOOKUP_STORAGE_KEY);
    },
    reuseExistingRequest() {
      this.show_existing_request_modal = false;
      this.applyPrefill(this.pending_prefill);
      this.payload.source_request_id = this.existing_request
        ? this.existing_request.id
        : null;
      this.reregister_email = this.payload.email;
      this.persistReregisterState();
      this.pending_prefill = null;
    },
    declineExistingRequest() {
      // blank form, keeping only the ID number and email already typed
      this.show_existing_request_modal = false;
      this.pending_prefill = null;
      this.clearReregisterState();
    },
    applyPrefill(prefill) {
      if (!prefill) return;

      for (const key of Object.keys(this.payload)) {
        if (
          NON_PREFILLABLE_FIELDS.includes(key) ||
          FILE_FIELDS.includes(key) ||
          ONBOARDING_REQUIREMENT_FIELDS.includes(key) ||
          key === "service_provider" ||
          key === "number_of_service_provider_agreements" ||
          !(key in prefill)
        ) {
          continue;
        }
        this.payload[key] = prefill[key] === undefined ? null : prefill[key];
      }

      // the calendars and the hijri/gregorian conversion need Date objects
      for (const key of DATE_FIELDS) {
        const parsed = this.parsePrefilledDate(prefill[key]);
        if (parsed) this.payload[key] = parsed;
      }

      for (const key of FILE_FIELDS) {
        this.payload[key] = prefilledFile(prefill[key]);
      }

      const onboarding = prefill.onboarding_requirement || {};
      for (const key of ONBOARDING_REQUIREMENT_FIELDS) {
        // a missing document is an absent key, so that slot simply starts empty
        this.payload[key] = prefilledFile(onboarding[key]);
      }

      this.applyPrefilledServiceProviders(prefill);

      // every OTP and the IBAN check is re-run, whatever the old request held
      for (const flag of VERIFICATION_FLAGS) {
        this.payload[flag] = false;
      }
    },
    // built component-wise: "YYYY-MM-DD" through the Date constructor is parsed
    // as UTC, which can land a day earlier once rendered locally — and a hijri
    // date is calendar digits, not an instant
    parsePrefilledDate(value) {
      if (!value || typeof value !== "string") return null;
      const [year, month, day] = value.split("-").map(Number);
      if (!year || !month || !day) return null;
      const parsed = new Date(year, month - 1, day);
      return isNaN(parsed.getTime()) ? null : parsed;
    },
    applyPrefilledServiceProviders(prefill) {
      const providers = Array.isArray(prefill.service_provider)
        ? prefill.service_provider
        : [];
      const count = prefill.number_of_service_provider_agreements || 0;

      // requests submitted before the backend fix stored no service providers
      // against a non-zero count, and submit rejects a length mismatch — so drop
      // the section and have the applicant re-enter it rather than fail at the end
      if (count && providers.length !== count) {
        this.prefill_sp_dropped = true;
        this.payload.number_of_service_provider_agreements = null;
        this.payload.service_provider = [];
        return;
      }

      this.prefill_sp_dropped = false;
      this.payload.number_of_service_provider_agreements = count || null;
      this.payload.service_provider = providers.map((provider) => ({
        ...provider,
        agreement_attachment: prefilledFile(provider.agreement_attachment),
      }));
    },
    persistReregisterState() {
      setLocalValue(REREGISTER_STORAGE_KEY, {
        source_request_id: this.payload.source_request_id,
        charity_request: this.existing_request,
        prefill: this.pending_prefill,
        email: this.reregister_email,
      });
    },
    // stops re-using the old request; the data already reviewed on screen stays,
    // because the applicant may well want to submit it as a fresh registration
    clearReregisterState() {
      this.payload.source_request_id = null;
      this.existing_request = null;
      this.reregister_email = null;
      this.prefill_sp_dropped = false;
      localStorage.removeItem(REREGISTER_STORAGE_KEY);
    },
    async setInitialPayload() {
      this.verified_info = getLocalValue("verified_info") || {};

      // applied first so anything the applicant has since edited in a step wins
      const reregister = getLocalValue(REREGISTER_STORAGE_KEY);
      if (reregister && reregister.source_request_id) {
        this.existing_request = reregister.charity_request || null;
        this.pending_prefill = reregister.prefill || null;
        this.applyPrefill(reregister.prefill);
        this.payload.source_request_id = reregister.source_request_id;
        this.reregister_email = reregister.email || null;
      }

      const lookup = getLocalValue(EMAIL_LOOKUP_STORAGE_KEY);
      if (lookup && lookup.email && lookup.match_type) {
        this.email_lookup = lookup;
      }

      const charityRequest = getLocalValue("charity_request");
      if (charityRequest) {
        for (let i = 1; i <= 6; i++) {
          const step = charityRequest[`step${i}`];
          if (step) {
            for (let key in step) {
              this.payload[key] = step[key];
            }
            this.active_step = i + 1;
          } else {
            this.active_step = i;
            break;
          }
        }
      }
      this.$router.push(`/create-account/${this.active_step}`);

      const uuidPattern =
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
      if (this.payload.iban && uuidPattern.test(this.payload.iban)) {
        this.payload.iban = await this.getIBANfromUUID(this.payload.iban);
      }
    },
    setStep() {
      this.active_step = parseInt(this.$route.params.step, 10);
    },
    closeModal() {
       // Clear timeout if user manually closes
      if (this.autoCloseTimeout) {
        clearTimeout(this.autoCloseTimeout);
        this.autoCloseTimeout = null;
      }
      this.open_modal = false;
      this.submit_error_message = null;
      if (this.is_success) {
        this.$router.push("/");
        localStorage.removeItem("charity_request");
        localStorage.removeItem("verified_info");
        localStorage.removeItem(REREGISTER_STORAGE_KEY);
        this.clearEmailLookup();
      }
    },
    async getIBANfromUUID(ibanUUID) {
      const response = await CharityRegisterService.getIBANfromUUID(ibanUUID);
      const iban = response.data.result.iban;
      return iban;
    },
    close() {
      if (this.active_step > 1) {
        this.$router.push(`/create-account/${this.active_step - 1}`);
      }
      else this.$router.push("/sign-in?tab=1");
    },
    next() {
      if (this.active_step < 6)
        this.$router.push(`/create-account/${this.active_step + 1}`);
      else this.$router.push("/sign-in?tab=1");
    },
    openVerificationStep() {
      this.open_verification_step = true;
      this.$router.push(`/create-account/6?open_verification=${true}`);
    },
    closeVerificationStep() {
      this.open_verification_step = false;
      this.$router.push(`/create-account/6`);
    },
    async fileChangeInProvider(event, index) {
     if (
       event &&
       event.target &&
       event.target.files &&
       event.target.files.length
     ) {
    const file = event.target.files[0];
    const base64File = await toBase64(file);
    try {
      this.loading = true;

      const response = await CharityRegisterService.uploadAttachment(base64File, `service_provider_${index}_agreement_attachment`);
      const url = response.data.url;

      this.payload.service_provider[index].agreement_attachment = {
        url,
        name: file.name,
        size: file.size,
      };

    } catch (e) {
      console.error("Upload failed", e);
    } finally {
      this.loading = false;
    }
  }
},
   removeFileFromProvider(index) {
     this.payload.service_provider[index].agreement_attachment = null;
   },
    addServiceProvider() {
      this.payload.service_provider.push({ hospital_id: null, discount: null, agreement_attachment: null });
    },
    removeServiceProvider(index) {
      this.payload.service_provider.splice(index, 1);
    },
    async fileChange(event, key) {
  if (
    event &&
    event.target &&
    event.target.files &&
    event.target.files.length
  ) {
    const file = event.target.files[0];
    const base64File = await toBase64(file);
    try {
      this.loading = true;

      const response = await CharityRegisterService.uploadAttachment(base64File, key);
      const url = response.data.url;
      this.payload[key] = {
        url,
        name: file.name,
        size: file.size,
      };
    } catch (e) {
      console.error("Upload failed", e);
    } finally {
      this.loading = false;
    }
  }
},
    removeFile(key) {
      this.payload[key] = null;
    },
    setPayload(key, val) {
      this.payload[key] = val;
    },
    startAutoCloseTimer() {
      if (this.autoCloseTimeout) {
        clearTimeout(this.autoCloseTimeout);
      }
      this.autoCloseTimeout = setTimeout(() => {
        this.closeModal();
      }, 5000);
    },
    async checkRegistrationOpen() {
      try {
        const { data } = await AuthService.getCharityLoginFlag();
        this.registration_closed = !data.result.add_a_new_association;
      } catch (error) {
        console.error("Failed to get charity login flag:", error);
      }
      return !this.registration_closed;
    },
    async createCharity() {
      // re-check on submit: the flag may have been turned off after the page loaded
      if (!(await this.checkRegistrationOpen())) {
        if (this.$refs.step6Verification) {
          this.$refs.step6Verification.loading = false;
        }
        return;
      }
      //file attachments with only base64 data are sent
      const data = {
        ...this.payload,
        service_provider: this.payload.service_provider
          ? this.payload.service_provider.map(sp => ({ ...sp }))
          : [],
      };
      data.charity_twitter = data.charity_twitter || null;
      for (const key of DATE_FIELDS) {
        if (data[key] instanceof Date) {
          data[key] = moment(data[key]).format("YYYY-MM-DD");
        }
      }
      // a pre-filled file is already an absolute URL the backend re-attaches
      data.charity_logo = this.attachmentUrl(data.charity_logo);
      data.license_attachment = this.attachmentUrl(data.license_attachment);
      data.bank_account_attachment = this.attachmentUrl(
        data.bank_account_attachment
      );

      if (!data.source_request_id) delete data.source_request_id;

      // Service Provider Attachments Handeling
      if(data.service_provider && data.service_provider.length) {
        for (const sp of data.service_provider) {
          if (sp.agreement_attachment) {
            sp.agreement_attachment = this.attachmentUrl(sp.agreement_attachment);
          }
        }
      }
      if(data.longitude){
        data.longitude = Number(data.longitude).toFixed(6);
      }
      if(data.latitude){
        data.latitude = Number(data.latitude).toFixed(6);
      }
      // Onboarding Requirement Attachments Handeling
      const onboarding_requirement = {};
      const attachmentKeys = [
        "auth_letter",
        "basic_regulations",
        "governance_report",
        "financial_statement",
        "patient_waitlist",
      ];
      for (const key of attachmentKeys) {
        if (data[key]) {
        onboarding_requirement[key] = this.attachmentUrl(data[key]);
        }
        delete data[key];
      }
      data.onboarding_requirement = onboarding_requirement;

      CharityRegisterService.createCharity(data)
        .then(() => {
          this.is_success = true;
          this.open_modal = true;
          localStorage.removeItem(REREGISTER_STORAGE_KEY);
           this.startAutoCloseTimer(); // start timer to autoclose modal
        })
        .catch((error) => {
          this.handleSubmitError(error);
        })
        .finally(() => {
          if (this.$refs.step6Verification) {
            this.$refs.step6Verification.loading = false;
          }
        });
    },
    attachmentUrl(attachment) {
      if (!attachment) return null;
      return attachment.url ? attachment.url : attachment;
    },
    handleSubmitError(error) {
      const data = error?.response?.data;
      const code = data?.error_code || null;

      // no response body at all (network/timeout): nothing was saved, retry is safe
      if (!data) {
        this.is_success = false;
        this.submit_error_message = SUBMIT_ERROR_MESSAGES.submission_failed;
        this.open_modal = true;
        return;
      }

      // 400 with no error_code is the ordinary field-error path
      if (!code) {
        // a coded failure sends errors as an array; the field-error path sends a
        // dict, and field_errors is what the step components read
        const fieldErrors = {
          ...(Array.isArray(data.errors) ? {} : data.errors || {}),
          ...(data.field_errors || {}),
        };
        for (const key in fieldErrors) {
          this.apierrors[key] = fieldErrors[key];
        }
        if (Object.keys(fieldErrors).length) {
          //redirect to step 2 so user goes through all errors  on all steps
          this.$router.push(`/create-account/2`);
          return;
        }
        // nothing to highlight: say so rather than bouncing to step 2 in silence
        this.is_success = false;
        this.submit_error_message = Array.isArray(data.errors) && data.errors.length
          ? data.errors[0]
          : null;
        this.open_modal = true;
        return;
      }

      this.is_success = false;
      this.submit_error_message =
        data?.errors?.length
          ? data.errors[0]
          : SUBMIT_ERROR_MESSAGES[code] || null;
      this.submit_locked = TERMINAL_SUBMIT_ERRORS.includes(code);
      this.open_modal = true;

      // the source request is gone or no longer reusable: drop it and send the
      // applicant back to re-run the email lookup
      if (
        code === "source_request_not_reusable" ||
        code === "source_request_not_found"
      ) {
        this.clearReregisterState();
        this.$router.push(`/create-account/1`);
      }
    },
  },
  watch: {
    $route() {
      this.setStep();
    },
    "payload.email": function (val) {
      if (this.email_lookup && val !== this.email_lookup.email) {
        this.clearEmailLookup();
      }
      // the backend checks the source request belongs to the submitted email, so
      // a mismatch would only fail at submit with the whole form filled in
      if (
        this.payload.source_request_id &&
        this.reregister_email &&
        val !== this.reregister_email
      ) {
        this.clearReregisterState();
      }
    },
    active_step(val) {
      if (
        val == 2 &&
        this.payload.the_charity_manager_is_the_chairman &&
        this.payload.chairman_mobile != this.payload.mobile_number
      ) {
        this.payload.chairman_mobile = this.payload.mobile_number;
      }
    },
  },
  eforeUnmount() {
    // Clean up timeout when component is destroyed
    if (this.autoCloseTimeout) {
      clearTimeout(this.autoCloseTimeout);
    }
  },
  mounted() {
    this.checkRegistrationOpen();
    this.setInitialPayload();
  },
  created() {
    this.gregorian_max_date = new Date();
    const dateHijriObj = toHijri(
      new Date().getFullYear(),
      new Date().getMonth() + 1,
      new Date().getDate()
    );
    this.hijri_max_date = new Date(
      dateHijriObj.hy,
      dateHijriObj.hm - 1,
      dateHijriObj.hd
    );
    this.payload.gregorian_birthdate = this.gregorian_max_date;
    this.payload.hijri_birthdate = this.hijri_max_date;
    this.payload.license_expiry_gregorian_date = this.gregorian_max_date;
    this.payload.license_expiry_hijri_date = this.hijri_max_date;
  },
};
</script>

<style lang="scss" scoped>
.createAccount-area {
  .container {
    padding: 0 0 45px 0;
  }

  .form-container {
    padding-top: 1rem;
  }

  .form-cont {
    padding: 2rem;
  }

  .logo {
    width: 30px;
    margin-left: 10px;
  }

  .createAccountform {
    background-color: #ffffff;
    border-radius: 10px;
    width: 70%;
    display: block;
    margin: 5px auto;
    direction: rtl;
    text-align: right;
    font-weight: lighter;
  }

  .btn:not(:disabled):not(.disabled) {
    cursor: pointer;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
  }

  .dir-rtl {
    direction: rtl;
  }

  :deep(.p-tabview .p-tabview-nav li) {
    width: 50% !important;
  }

  :deep(.p-tabview .p-tabview-nav li .p-tabview-nav-link) {
    display: block;
    text-align: center;
  }

  :deep(
      .p-tabview .p-tabview-nav li .p-tabview-nav-link:not(.p-disabled):focus
    ) {
    box-shadow: none;
  }

  :deep(.p-float-label > label) {
    left: 0 !important;
    right: 0.75rem;
  }
}
</style>

<style lang="scss">
.p-steps-title {
  color: transparent !important;
}

.p-steps .p-steps-item.p-highlight .p-steps-number {
  background: #12b2aa !important;
  color: #ffffff !important;
}

.p-steps .p-steps-item:before,
.p-steps .p-steps-item .p-menuitem-link .p-steps-number {
  border-color: #b2b2b2 !important;
}

.p-steps .p-steps-item:first-child:before {
  left: 0;
  width: 50%;
}

.p-steps .p-steps-item:last-child:before {
  left: 50%;
  width: 50%;
}
</style>
